import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import axios from '../../../axios';

import useReportStore from '../../../store/reports';

import MuiAutocompleteMulti from '../../../utils/MuiFields/MuiAutocompleteMulti';

import { useQuery } from '@tanstack/react-query';


const prefetchOptions = async (url) => {
  try {
    const { data } = await axios.get(url);
    return data?.rows;
  } catch (e) {
    return null;
  }
}

const AutoMulti = ({ field, subfield = "$in", label, url, values, fieldOptions, prefetch, additionalCollections }) => {

  const reportType = useReportStore(state => state.reportType);
  const resetFilters = useReportStore(state => state.resetFilters);
  const handleFilter = useReportStore(state => state.handleFilter);
  let fieldValue = useReportStore(state => state.filters[reportType]?.[field]) || {};

  const [ serverOptions, setServerOptions ] = useState(values || []);

  let { fieldName, displayField } = fieldOptions || {};

  const onChange = (ids) => {
    if (ids?.length) {
      handleFilter(ids, reportType, field, subfield, "array");
    } else {
      resetFilters(reportType, field, subfield, false);
    }
  }

  console.log(values, "values", fieldOptions, "fieldOptions", fieldValue, "fieldValue");

  console.log(url, prefetch, "url, prefetch");
  const { data: options } = useQuery({
    queryKey: [url],
    queryFn: () => prefetchOptions(url),
    enabled: !!prefetch && !!url,
    staleTime:  30 * 60 * 1000
  })

  useEffect(() => {
    if (options) {
      setServerOptions(options);
    }
  }, [options])

  let multiUrl = url?.startsWith('/') ? url?.substring(1) : url;

  return (
    <MuiAutocompleteMulti
      multiple={true}
      fieldName={fieldName}        // The unique key in your data
      displayField={displayField || fieldName}   // The property to show in the UI
      value={fieldValue?.$in}   // Array of strings/IDs
      onChange={onChange}
      url={multiUrl}     // Endpoint for debounced search
      serverOptions={serverOptions}
      additionalCollections={additionalCollections}
      style={{ backgroundColor: "#f8f8f8" }}
    />
  );
};

export default AutoMulti;